var tw = tw || {};
tw.GeopointReportsListings = (function () {
	//test.
	var _log = true,
		basePath = decodeURIComponent($("[data-basepath]").data("basepath")),
		$reports = $('.js-reports'),
		initUgc = true,

		//TEMPLATES
		reportDetailsSSTemplate = $('#reportDetailsSSTemplate').html(),
		preloaderTemplate = $('#preloaderTemplate').html()

	;




	/**
	 * Get All Reports By Region
	 */
	var getAllReportsByRegion = function () {
		if (_log) console.log('getAllReportsByRegion()');

		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate(),
			reportType = BingMap.Map.getReportType();
		$('#reportsAll').html(htmlPreloader);

		if (_log) console.log('reportType:', reportType);

		$.ajax({
			url: basePath + '/getallreportsbyregion',
			data: {
				"reportType": reportType
			},
			type: "GET",
			success: function (data) {
				if (_log) console.log('getAllReportsByRegion.data.length:', data.length);
				BingMap.Map.addPushpinCluster(data);
			},
			error: function (xhr, status, error) {
				console.error(xhr, status, error);
			}
		});
	};



	var showReports = function () {
		//if (_log) console.log('showReports()');
    $reports.removeClass('is-hidden');
    tw.GeopointReports.checkFixed();
		tw.GeopointReports.setPaneRecords();
	};

	var hideReports = function () {
		$reports.addClass('is-hidden');
	};

	var clearDetailsShowAll = function () {
		if(_log) console.log('clearDetailsShowAll()');
		emptyReportDetails();
		tw.GeopointReports.closeSubpanes();
		showReports();
	}

	/**
	 * Empty ReportDetails container div
	 */
	var emptyReportDetails = function () {
		if (_log) console.log('emptyReportDetails()');
		$('#reportDetails').html('');
		$('#reportPhotos').html('');
	}

	var showReportSubpane = function (Id) {
		//console.log('showReportSubpane().Id: ', Id);
		//close any open subpanes
		tw.GeopointReports.closeSubpanes();
		tw.GeopointReports.openSubpane({
			subpane: Id
		});
	};


	/**
	 * Get Report Details
	 * @param {*} reportId 
	 */
	var getReportDetails = function (reportId) { //, count
		if (_log) console.group('getReportDetails()');
		if (_log) console.log('reportId:', reportId);
		// if (_log) console.log('count:', count);

		emptyReportDetails();
		var compiledTemplate = Template7.compile(preloaderTemplate),
			htmlPreloader = compiledTemplate(),
			reportType = BingMap.Map.getReportType();
		$('#reportDetails').html(htmlPreloader);

		$.ajax({
			url: basePath + '/reportdetails',
			type: "POST",
			data: {
				id: reportId,
				reportType: reportType
			},
			success: function (data) {
				if (_log) console.log('getReportDetails.data: ', data);
				addReportDetails(data, reportType);
			},
			error: function (xhr, status, error) {
				console.log(xhr, status, error);
			}
		});

		if (_log) console.log('reportType:', reportType);
		if (_log) console.groupEnd();
	};



	/**
	 * Add Report Details to Stage
	 * @param {*} data 
	 */
	var addReportDetails = function (data, reportType) { //count, 
		if (_log) console.log('addReportDetails()', data, reportType); //count, 

		var useTemplate = reportDetailsSSTemplate,
			compiledTemplate = Template7.compile(useTemplate);

		var jsonContent = {
			City: data.City,
			CountyID: data.CountyID,
			Description: data.Description,
			ID: data.ID,
			Images: data.Images,
			Latitude: data.Latitude,
			Longitude: data.Longitude,
			Address: data.Address,
			Zip: data.Zip,
			State: data.State,
			IsHandicapAccessible: data.IsHandicapAccessible,
            HandicapInstructions: data.HandicapInstructions,
			UGCFeed: data.UGCFeed,
			Directions: data.Directions,
			LocationUrl: (data.LocationUrl != '' && data.LocationUrl != 'http://') ? data.LocationUrl : '',
			ModifiedDate: data.ModifiedDate,
			RegionName: data.RegionName,
			RegionID: data.RegionID,
			Title: data.Title,
			Url: data.Url
		};

		//console.log('jsonContent:', jsonContent);
		var html = compiledTemplate(jsonContent);
		$('#reportDetails').html(html);


		//console.log('data.UGCFeed:', data.UGCFeed);
    	if (data.UGCFeed != null && data.UGCFeed != '') {
			initializeUGC(data.UGCFeed, 'reportPhotos');
		}

		showReportSubpane('report-detail');

		tw.GeopointReports.setPaneRecords('report-detail');
		BingMap.Map.zoomToPin(data.Latitude, data.Longitude);
		BingMap.Map.showInfobox(data);

	}



	/**
	 * Initialize User Generated Content
	 * 
	 * USE VANILLA JS FOR CROWDRIFF. USING JQUERY COMMANDS WILL BREAK PATHING SCOPE.
	 * $('#loaderUGC').append(s);//<--will break
	 * loaderUGC.append(s);//<--will also break on IE. use appendChild
	 * 
	 * @param {*} data 
	 * @param {*} divId 
	 */
	var initializeUGC = function (data, divId) {
		//console.log('initializeUGC');
		//console.log('window1:', window);

		if (!initUgc) {
			//If UGC has been initialized already, clear out the rendered array
			window.crowdriff__gallery.rendered = [];
			//console.log('window.crowdriff__gallery:', window.crowdriff__gallery);
		}

		var s = document.createElement("script");
		s.type = "text/javascript";
		s.src = "https://starling.crowdriff.com/js/crowdriff.js";
		s.id = data; //"cr-init__1b59e2be8c775f33"
		var loaderUGC = document.getElementById(divId);
		loaderUGC.appendChild(s);
		//console.log('appendChild.s:', s);


		if (!initUgc) {
			//If UGC has been initialized already, restart interval to process Queue
			//console.log('window.crowdriff__gallery.interval:', window.crowdriff__gallery.interval);
			if (window.crowdriff__gallery && !window.crowdriff__gallery.interval) {
				window.crowdriff__gallery.interval = setInterval(window.crowdriff__gallery.processQueue, 300);
			}
		}

		initUgc = false;
		//console.log('window:', window);

	}


	return {
		addReportDetails: addReportDetails,
		clearDetailsShowAll: clearDetailsShowAll,
		emptyReportDetails: emptyReportDetails,
		hideReports: hideReports,
		getAllReportsByRegion: getAllReportsByRegion,
		getReportDetails: getReportDetails,
		showReports: showReports,
		initializeUGC: initializeUGC
	}
}());